import React, { useEffect, useRef, useState } from "react";
import MTable from "../../Components/MTable/MTable";
import { InputSwitch } from "primereact/inputswitch";
import { useNavigate } from "react-router-dom";
import {
  getSkuAll,
  softDeleteSku,
  getSubcategoryPrefixs,
  deleteSku,
  copySku,
} from "../../Services/SkuService";
import { handlerFormError, uuid } from "../../Utils/Utils";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { NavLink } from "react-router-dom";
import Modal from "../../Components/Layout/Modal";
import Swal from "sweetalert2";
import Overlay from "../../Components/Overlay/Overlay";
import { useSelector } from "react-redux";
import EditButton from "../../Components/Button/EditButton";
import DeleteButton from "../../Components/Button/DeleteButton";
import CustomButton from "../../Components/Button/CustomButton";

const { $ } = window;
const modalId = "#sku-modal";
const modalId2 = "#sku-modal2";

let processingId = -1;

const SkuPage = () => {
  let { userInfo } = useSelector((state) => state.auth);
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();
  const mTable = useRef();

  const [state, setState] = useState({
    selectedSubCatId: null,
    prefixs: [],
    action: "edit",
    fromPrefix: "",
    toPrefix: "",
    processing: false,
  });

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onCopy = (item) => {
    setState({ ...state, prefixs: [], selectedSubCatId: null });
    getSubcategoryPrefixs(item.id_sub_category, ({ data }) => {
      setState({
        ...state,
        prefixs: data,
        selectedSubCatId: item.id_sub_category,
      });
      $(modalId2).modal("show");
    });
  };

  const onFormPrefixChange = (e) => {
    setState({ ...state, fromPrefix: e.target.value });
  };

  const onToPrefixChange = (e) => {
    setState({ ...state, toPrefix: e.target.value });
  };

  const onModal = (item, action) => {
    setState({ ...state, prefixs: [], selectedSubCatId: null, action: false });
    getSubcategoryPrefixs(item.id_sub_category, ({ data }) => {
      setState({
        ...state,
        prefixs: data,
        selectedSubCatId: item.id_sub_category,
        action,
      });
      $(modalId).modal("show");
    });
  };

  const onCopyPrefix = () => {
    const data = {
      id_sub_category: selectedSubCatId,
      from_prefix: fromPrefix,
      to_prefix: toPrefix,
    };

    startProcessing();

    copySku(data)
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          Swal.fire({
            icon: "success",
            title: "Duplicate SKU success",
            text: "Data has been saved!",
          }).then((r) => {
            setState({
              ...state,
              selectedSubCatId: "",
              fromPrefix: "",
              toPrefix: "",
            });
            $(modalId2).modal("hide");
            mTable.current.refresh();
          });
        }
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
      })
      .finally((_) => stopProcessing());
  };

  const onSelectEdit = (prefix) => {
    $(modalId).modal("hide");
    navigate(`edit/${selectedSubCatId}/prefix/${prefix}`);
  };

  const onSelectToRemove = (prefix) => {
    if (!userInfo.access.master.can_delete) {
      toastError("You dont have permission for this action");
      return;
    }

    Swal.fire({
      icon: "question",
      title: "Delete prefix?",
      text: "Deleted subcategory prefix can not be restored",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        $(modalId).modal("hide");
        deleteSku(selectedSubCatId, prefix)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Delete data success",
              text: "Delete has been updated!",
            }).then((r) => {
              setState({
                ...state,
                selectedSubCatId: null,
                prefixs: [],
                action: "edit",
              });
              mTable.current.refresh();
            });
          })
          .catch(({ response: { data } }) => {
            handlerFormError(data);
          });
      }
    });
  };

  const onCloseModal = () => {
    $(modalId).modal("hide");
  };

  const onCloseModal2 = () => {
    setState({
      ...state,
      selectedSubCatId: null,
      prefixs: [],
      action: "edit",
    });
    $(modalId2).modal("hide");
  };

  const columns = [
    {
      id: uuid(),
      title: "Segment Name",
      field: "segment_name",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Category Name",
      field: "category_name",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Subcategory Name",
      field: "sub_category_name",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Header Codes",
      field: "header_codes",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Active",
      field: "is_active",
      render: (item) => {
        if (item.is_active === true) {
          return <span className="badge badge-success">Active</span>;
        } else {
          return <span className="badge badge-secondary">Inactive</span>;
        }
      },
    },
    {
      id: uuid(),
      title: "Action",
      style: {
        width: "20%",
      },
      render: (item) => {
        return (
          <div>
            <EditButton title="Edit" onClick={() => onModal(item, "edit")} />
            <DeleteButton
              title="Remove"
              onClick={() => onModal(item, "delete")}
            />
            <CustomButton
              title="Copy"
              type="default"
              icon="fas fa-paste"
              onClick={() => onCopy(item)}
            />
          </div>
        );
      },
    },
  ];

  const onAddData = () => {
    navigate("add");
  };

  const onActiveChange = (item) => (e) => {
    if (!userInfo.access.sku_config.can_update) {
      toastError("You dont have permission for this action");
      return;
    }

    const status = e.target.value ? "Activate" : "Inactive";
    softDeleteSku(item.id_sub_category, { is_active: e.target.value })
      .then((res) => {
        toastSuccess(`${status} Success.`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} Failed.`);
      });
  };

  const showAllFunc = () => {
    setShowAll(!showAll);
    mTable.current.refresh();
  };

  const propsTable = {
    columns,
    showAllState: showAll,
    showAllFunc,
    getData: (params) => {
      if (showAll === false) {
        if (params.filterAnd) params.filterAnd += "," + `is_active:true`;
        else params.filterAnd = "is_active:true";
      }
      return getSkuAll({ ...params });
    },
    showIndex: true,
    showAddButton: userInfo.access.sku_config.can_create,
    onAddData,
    enableFilter: true,
    filterRule: "filter",
    orders: "id_sub_category:asc",
  };

  const {
    prefixs,
    selectedSubCatId,
    action,
    fromPrefix,
    toPrefix,
    processing,
  } = state;

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4
                style={{
                  marginTop: "0.5rem",
                  marginLeft: "0.2rem",
                  fontWeight: "400",
                }}
              >
                {"SKU Header Management"}
              </h4>
              <h6
                style={{
                  marginLeft: "0.2rem",
                  fontWeight: "200",
                  letterSpacing: "1.2px",
                }}
              >
                {"Database of SKU Headers"}
              </h6>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">SKU Header</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <MTable ref={mTable} {...propsTable} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        id={modalId}
        title={
          action == "edit"
            ? "Edit Subcategory Prefix"
            : "Delete Subcategory Prefix"
        }
        onClose={onCloseModal}
        isLoading={processing}
      >
        <div className="col-md-12">
          {prefixs.map((item) =>
            action == "edit" ? (
              <div
                style={{
                  border: "1px solid #ccc",
                  padding: 10,
                  marginBottom: 5,
                  borderRadius: 10,
                  cursor: "pointer",
                }}
                key={item}
                onClick={() => onSelectEdit(item)}
              >
                {item}
              </div>
            ) : (
              <div
                style={{
                  border: "1px solid #ccc",
                  padding: 10,
                  marginBottom: 5,
                  borderRadius: 10,
                  cursor: "pointer",
                }}
                key={item}
                onClick={() => onSelectToRemove(item)}
              >
                {item}
              </div>
            )
          )}
        </div>
      </Modal>

      <Modal
        id={modalId2}
        title="Copy Config To A New Prefix"
        onClose={onCloseModal2}
        onAction={onCopyPrefix}
        btnActionName="Copy"
        btnActionDisabled={!userInfo.access.sku_config.can_create}
      >
        <Overlay display={processing} />
        <div className="col-md-12">
          <div className="form-group">
            <label>From Prefix</label>
            <select
              name="prefix"
              className="form-control"
              value={fromPrefix}
              onChange={onFormPrefixChange}
            >
              <option value="">Select Prefix</option>
              {prefixs.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>To New Prefix</label>
            <input
              name="new-prefix"
              className="form-control"
              value={toPrefix}
              onChange={onToPrefixChange}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SkuPage;
